class StickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.sticky = this;
        this.stickyBounds = document.getElementById('product-add-to-cart') || document.querySelector('[data-combo-addtocart]');
        this.closeSticky = this.querySelector('[data-close-sticky-add-to-cart]');
        this.expandSticky = this.querySelector('[data-expand-sticky-add-to-cart]');

        this.closeSticky?.addEventListener(
            'click',
            this.setCloseSticky.bind(this)
        );

        this.expandSticky?.addEventListener(
            'click',
            this.setExpandSticky.bind(this)
        );
            
        this.openStickyButton = document.getElementById('show-sticky-product');
        this.closeModal = this.closeStickyModal.bind(this);
    }

    connectedCallback(){
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.openStickyButton.addEventListener('click', this.openStickyModal.bind(this));
        document.addEventListener('click', (e) => {
            if (e.target.matches('.background-overlay') || e.target.closest('[data-close-sticky-mobile]') != null || e.target.matches('[data-close-sticky-mobile]') || e.target.matches('.sticky-close-bg')) {
                this.closeModal();
            }
        })

        const height = this.closest('[data-sticky-add-to-cart]').clientHeight || 65;
        this.sticky.querySelector('.sticky-product-mobile').style.bottom = height + 'px';
    }

    openStickyModal() {
        $('.productView-stickyCart.not-detail').addClass('hidden');
        document.body.classList.add('show-mobile-options');
        var isSelectSize = $('variant-radios').find('.product-form__input:not(.product-form__swatch) input:checked'); 
        if ((!isSelectSize.length && !$('.bundles-size').length) || ($('.bundles-size').length && isSelectSize.length < 2)) {
            if (!$('.bundles-size').length) {
                var colorValue = $('variant-radios').find('.product-form__input.product-form__swatch input:checked').val();
                $('variant-sticky-radios').find('.product-form__swatch .product-form__radio[value="'+ colorValue +'"]').click();
            } else {
                var sizeValue = $('variant-radios').find('.product-form__input input:checked').val();
                var index = $('variant-radios').find('.product-form__input input:checked').closest('.product-form__input').attr('data-option-index');
                $('variant-sticky-radios').find('[data-option-index="'+ index +'"]').find('.product-form__radio[value="'+ sizeValue +'"]').click();
            }
            
        } else {
            var id = $('variant-radios').closest('.productView-details').find('[name="id"]').val();
            $('sticky-add-to-cart').find('[name="id"]').val(id);
            // 更新价格和按钮
            var getVariantData = JSON.parse($('variant-radios').find('[type="application/json"]').text() || '[]');
            var variantList = getVariantData.filter((variant) => {
                return variant.id == id;
            }); 
            if (variantList.length) {
                var price = Shopify.formatMoney(variantList[0].price, window.money_format);
                $('[data-sticky-add-to-cart] .sticky-price .money-subtotal').text(price);
                if (!variantList[0].available) {
                    var stickyButton = $('[data-sticky-add-to-cart]').find('[name="add"]');
                    var text = window.variantStrings.soldOut;
                    stickyButton.attr('disabled', true).text(text);
                }
            }
        }
        this.productImageGalleryMobile($('.halo-productView'));
    }

    productImageGalleryMobile ($scope) {
        var sliderFor = $scope.find('.productView-for:not(".mobile")'),
            sliderForMobile = $scope.find('.productView-for.mobile');
        if(!sliderForMobile.hasClass('slick-initialized')) {
            const thumbnailToShow = parseInt(sliderFor.data('max-thumbnail-to-show'));

            sliderForMobile.on('init',(event, slick) => {
                sliderForMobile.find('.animated-loading').removeClass('animated-loading');
            });

            sliderForMobile.slick({
                lazyLoad: 'ondemand',
                slidesToShow:  parseInt(sliderForMobile.data('max-thumbnail-to-show')),
                slidesToScroll: 1,
                asNavFor: false,
                arrows: true,
                dots: false,
                draggable: false,
                adaptiveHeight: false,
                focusOnSelect: true,
                vertical: true,
                verticalSwiping: true,
                infinite: true,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                rtl: window.rtl_slick,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            vertical: false,
                            verticalSwiping: false
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2.2,
                            slidesToScroll: 1,
                            vertical: false,
                            verticalSwiping: false
                        }
                    }
                ]
            });
        }
    }

    closeStickyModal() {
        document.body.classList.remove('show-mobile-options');
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (!this.stickyBounds) return;
        let offsetScroll = $(this.stickyBounds).offset().top + $(this.stickyBounds).outerHeight(true) + 100;
        var gw = $(this.stickyBounds).siblings('.gwbutton');
        if (gw.length) {
            offsetScroll = gw.offset().top + gw.outerHeight(true) + 100;
        }
        const winHeight = window.innerHeight;
        const docHeight = document.body.clientHeight;

        if (scrollTop > offsetScroll && scrollTop + winHeight < docHeight) {
            requestAnimationFrame(this.show.bind(this));

            if (this.sticky.classList.contains('style-1')) {
                let height = 0;
                const previewBar = document.getElementById('preview-bar-iframe'),
                    toolbarMobile = document.querySelector('.halo-sticky-toolbar-mobile');

                if (previewBar && window.getComputedStyle(previewBar).display !== "none") {
                    height = previewBar.offsetHeight;
                }
                else if (toolbarMobile) {
                    height = toolbarMobile.offsetHeight;
                }
                if (window.innerWidth < 768 && $('.collection-popup-block').length) {
                    height = height + 50;
                }

                this.sticky.style.top = 'auto';
                this.sticky.style.bottom = `${height}px`;
            }
            else if (this.sticky.classList.contains('style-2')) {
                if(document.body.classList.contains('scroll-up')){
                    let height = document.querySelector('sticky-header').offsetHeight;

                    if (window.innerWidth < 551) {
                        height = height + 20;
                    }

                    this.sticky.style.top = `${height}px`;
                } else if(document.body.classList.contains('scroll-down')) {
                    if (window.innerWidth > 550) {
                        this.sticky.style.top = 0;
                    }
                    else {
                        this.sticky.style.top = '20px';
                    }
                }
            }
        } else{
            requestAnimationFrame(this.hide.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.sticky.classList.remove('show-sticky', 'hidden-sticky', 'full-sticky', 'animate');
        document.body.classList.remove('show-mobile-options');
    }

    show() {
        this.sticky.classList.add('show-sticky', 'animate');
    }

    setCloseSticky(event){
        event.preventDefault();

        if(this.sticky.classList.contains('full-sticky')){
            this.sticky.classList.remove('full-sticky');
        } else{
            this.sticky.classList.add('hidden-sticky');
        }
    }

    setExpandSticky(event){
        event.preventDefault();

        this.sticky.classList.add('full-sticky');
    }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);

class VariantStickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        if (!this.item.length) {
            this.item = $('.productView');
        }
        this.sticky = $(this).closest('.productView-stickyCart');
        if (!this.sticky.length) {
            this.sticky = $('.productView-stickyCart');
        }
        this.addEventListener('change', this.onVariantChange.bind(this));
    }
    onVariantChange(event) {
        this.updateOptions();   
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateMedia(200);
        if (!$('.combined-size:not(.active)').length) {
            // this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        this.updateAttribute(!this.currentVariant.available);
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
    
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }

    updateMasterId() {
        this.decodeOptions()
        this.currentVariant = this.getVariantData().find((variant) => {
            return variant.id == this.options;
        });
    }

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;

        const itemImage = this.item.find('.sticky-image');
        const image = this.currentVariant?.featured_image;
        if (!itemImage) return;

        itemImage.find('img').attr({
            'src': image.src,
            'srcset': image.src,
            'alt': image.alt
        });

        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;
        window.setTimeout(() => {
            $(newMedia).trigger('click');
        }, time);
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}, #product-form-sticky-${this.dataset.product}`);
  
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (this.currentVariant) {
                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {
        if (!this.currentVariant) return false;
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }

                document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
        });
    }

    renderProductInfo() {
        var variantList = this.getVariantData().filter((variant) => {
            return variant.available
        }); 
        if (!this.currentVariant) return;
        var selectedOption1 = this.currentVariant?.option1,
            selectedOption2 = this.currentVariant?.option2,
            selectedOption3 = this.currentVariant?.option3,
            options = this.item.find('.product-form__input:not(.mobile)'),
            optionsMobile = this.item.find('.product-form__input.mobile'),
            checkStickyVariant = false;
        // let parsedSelectedOption1 = selectedOption1 ? parseDoubleQuote(selectedOption1) : null,
        //     parsedSelectedOption2 = selectedOption2 ? parseDoubleQuote(selectedOption2) : null,
        //     parsedSelectedOption3 = selectedOption3 ? parseDoubleQuote(selectedOption3) : null;

        const renderOptions = (options) => {
            $.each(options, (index, element) => {
                var position = $(element).data('option-index'),
                    type = $(element).data('product-attribute');
                
                switch (position) {
                    case 0:
                        $(element).find('[data-header-option]').text(selectedOption1);
    
                        if(type == 'set-select') {
                            $(element).find('.select__select').val(selectedOption1);
    
                            var selectList = $(element).find('.select__select option');
    
                            selectList.each((idx, elt) => {
                                if(elt.value == selectedOption1){
                                    $(elt).attr('selected', 'selected');
                                } else {
                                    $(elt).removeAttr('selected');
                                }
                            });
                        } else {
                            $(element).find('.product-form__radio').prop('checked', false);
                            $(element).find(`.product-form__radio[value="${this.encodeOption(selectedOption1)}"]`).prop('checked', true);
                        }
    
                        var option1List = variantList.filter((variant) => {
                            return variant.option1 === selectedOption1;
                        });
    
                        if(selectedOption2){
                            var inputList = $(options[1]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option');
    
                            if(type == 'set-rectangle'){
                                input.each((idx, elt) => {
                                    var $input = $(elt),
                                        $label = $input.next(),
                                        optionValue = $(elt).val();

                                    var optionSoldout = option1List.find((variant) => {
                                        return variant.option2 == this.decodeOption(optionValue)
                                    });
    
                                  if(optionSoldout == undefined){
                                      $label.removeClass('available').addClass('soldout');
                                      if (checkStickyVariant) {
                                          $(inputSticky[idx]).next().removeClass('available').addClass('soldout');
                                      }
                                  } else {
                                      $label.removeClass('soldout').addClass('available');
                                      if (checkStickyVariant) {
                                          $(inputSticky[idx]).next().removeClass('soldout').addClass('available');
                                      }
                                  }
                                });
                            } else {
                                selectOption.each((idx, elt) => {
                                    var $option = $(elt),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option1List.find((variant) => {
                                        return variant.option2 == this.decodeOption(optionValue)
                                    });
    
                                  if(optionSoldout == undefined){
                                      $option.attr('disabled', true);
                                      if (checkStickyVariant) {
                                          $(selectOptionSticky[idx]).attr('disabled', true);
                                      }
                                  } else {
                                      $option.removeAttr('disabled');
                                      if (checkStickyVariant) {
                                          $(selectOptionSticky[idx]).removeAttr('disabled');
                                      }
                                  }
                                });
                            }
                        }
    
                        if(selectedOption3){
                            var inputList = $(options[2]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option');
    
                            if(type == 'set-rectangle'){
                                input.each((idx, elt) => {
                                    var $input = $(elt),
                                        $label = $input.next(),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option1List.find((variant) => {
                                        return variant.option3 == this.decodeOption(optionValue)
                                    });
    
                                  if(optionSoldout == undefined){
                                      $label.removeClass('available').addClass('soldout');
                                      if (checkStickyVariant) {
                                          $(inputSticky[idx]).next().removeClass('available').addClass('soldout');
                                      }
                                  } else {
                                      $label.removeClass('soldout').addClass('available');
                                      if (checkStickyVariant) {
                                          $(inputSticky[idx]).next().removeClass('soldout').addClass('available');
                                      }
                                  }
                                });
                            } else {
                                electOption.each((idx, elt) => {
                                    var $option = $(elt),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option1List.find((variant) => {
                                        return variant.option3 == this.decodeOption(optionValue)
                                    });
    
                                  if(optionSoldout == undefined){
                                      $option.attr('disabled', true);
                                      if (checkStickyVariant) {
                                          $(selectOptionSticky[idx]).attr('disabled', true);
                                      }
                                  } else {
                                      $option.removeAttr('disabled');
                                      if (checkStickyVariant) {
                                          $(selectOptionSticky[idx]).removeAttr('disabled');
                                      }
                                  }
                                });
                            }
                        }
                        
                        break;
                    case 1:
                        $(element).find('[data-header-option]').text(selectedOption2);

                        try {
                            var specialSizes = $(element).closest('.productView-options').attr('data-special-sizes');
                            if (specialSizes) {
                                var S = this
                                var sizes = JSON.parse(specialSizes);
                                var sku =  $('variant-sticky-radios .product-form__swatch').find('input:checked') ?  $('variant-sticky-radios .product-form__swatch').find('input:checked').attr('data-sku') : $('[data-sku] .productView-info-value').html();
                                if (sku.indexOf(sizes.handle) > -1) {
                                    var hideSizesMap = {}; // 用对象存储需要隐藏的尺寸，减少 indexOf 查找次数
                                    var matchedSpu = false; // 是否找到匹配的 spu
                                    sizes.productUnits.forEach(function(dc) {
                                        if (sku.indexOf(dc.spu) > -1) {
                                            matchedSpu = true;
                                            dc.sizes.forEach(function(size) {
                                                hideSizesMap[size] = true; // 直接用对象存储，判断更快
                                            });
                                        }
                                    });
    
                                    // 遍历 radio 选项，一次性完成 `hidden` 处理 & 选择新尺寸
                                    var newSelectedSize = null;
    
                                    $(element).find('.product-form__radio').each(function () {
                                        var value = $(this).val();
                                        var $label = $(this).next();
    
                                        if (hideSizesMap[value]) {
                                            $label.addClass('hidden'); // 需要隐藏
                                        } else {
                                            $label.removeClass('hidden'); // 需要显示
    
                                            // 选择第一个可用尺寸
                                            if (!newSelectedSize && $label.hasClass('available')) {
                                                newSelectedSize = value;
                                            }
                                        }
                                    });
    
                                    // 如果当前选中的尺寸被隐藏，就自动选择新尺寸
                                    if (S.currentVariant && matchedSpu && hideSizesMap[S.currentVariant.option2] && newSelectedSize) {
                                        $(element).find('.product-form__radio[value="' + newSelectedSize + '"]').click();
                                        selectedOption2 = newSelectedSize;
                                    }
                                    
                                }
                            }
                        } catch (err) {}
    
                        if(type == 'set-select') {
                            $(element).find('.select__select').val(selectedOption2);
    
                            var selectList = $(element).find('.select__select option');
    
                            selectList.each((idx, elt) => {
                                if(elt.value == selectedOption2){
                                    $(elt).attr('selected', 'selected');
                                } else {
                                    $(elt).removeAttr('selected');
                                }
                            });
                        } else {
                            $(element).find('.product-form__radio').prop('checked', false);
                            $(element).find(`.product-form__radio[value="${this.encodeOption(selectedOption2)}"]`).prop('checked', true);
                        }
    
                        var option2List = variantList.filter((variant) => {
                            return variant.option2 === selectedOption2;
                        });
    
                        if(selectedOption1){
                            var inputList = $(options[0]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option');
    
                            if(type == 'set-rectangle'){
                                input.each((idx, elt) => {
                                    var $input = $(elt),
                                        $label = $input.next(),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option2List.find((variant) => {
                                        return variant.option1 == this.decodeOption(optionValue)
                                    });
    
                                    if(optionSoldout == undefined && !$('.combined-size:not(.active)').length){
                                        $label.removeClass('available').addClass('soldout');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('available').addClass('soldout');
                                        }
                                    } else {
                                        $label.removeClass('soldout').addClass('available');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('soldout').addClass('available');
                                        }
                                    }
                                });
                            } else {
                                selectOption.each((idx, elt) => {
                                    var $option = $(elt),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option2List.find((variant) => {
                                        return variant.option1 == this.decodeOption(optionValue)
                                    });
    
                                    if(optionSoldout == undefined){
                                        $option.attr('disabled', true);
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).attr('disabled', true);
                                        }
                                    } else {
                                        $option.removeAttr('disabled');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).removeAttr('disabled');
                                        }
                                    }
                                });
                            }
                        }
    
                        if(selectedOption3){
                            var inputList = $(options[2]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option');
    
                            if(type == 'set-rectangle'){
                                input.each((idx, elt) => {
                                    var $input = $(elt),
                                        $label = $input.next(),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option2List.find((variant) => {
                                        return variant.option3 == this.decodeOption(optionValue)
                                    });
    
                                    if(optionSoldout == undefined){
                                        $label.removeClass('available').addClass('soldout');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('available').addClass('soldout');
                                        }
                                    } else {
                                        $label.removeClass('soldout').addClass('available');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('soldout').addClass('available');
                                        }
                                    }
                                });
                            } else {
                                electOption.each((idx, elt) => {
                                    var $option = $(elt),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option2List.find((variant) => {
                                        return variant.option3 == this.decodeOption(optionValue)
                                    });
    
                                    if(optionSoldout == undefined){
                                        $option.attr('disabled', true);
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).attr('disabled', true);
                                        }
                                    } else {
                                        $option.removeAttr('disabled');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).removeAttr('disabled');
                                        }
                                    }
                                });
                            }
                        }
                        
                        break;
                    case 2:
                        $(element).find('[data-header-option]').text(selectedOption3);
    
                        if(type == 'set-select') {
                            $(element).find('.select__select').val(selectedOption3);
    
                            var selectList = $(element).find('.select__select option');
    
                            selectList.each((idx, elt) => {
                                if(elt.value == selectedOption3){
                                    $(elt).attr('selected', 'selected');
                                } else {
                                    $(elt).removeAttr('selected');
                                }
                            });
                        } else {
                            $(element).find('.product-form__radio').prop('checked', false);
                            $(element).find(`.product-form__radio[value="${this.encodeOption(selectedOption3)}"]`).prop('checked', true);
                        }
    
                        var option3List = variantList.filter((variant) => {
                            return variant.option3 === selectedOption3;
                        });
    
                        if(selectedOption1){
                            var inputList = $(options[0]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option');
    
                            if(type == 'set-rectangle'){
                                input.each((idx, elt) => {
                                    var $input = $(elt),
                                        $label = $input.next(),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option3List.find((variant) => {
                                        return variant.option1 == this.decodeOption(optionValue)
                                    });
    
                                     if(optionSoldout == undefined){
                                        $label.removeClass('available').addClass('soldout');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('available').addClass('soldout');
                                        }
                                    } else {
                                        $label.removeClass('soldout').addClass('available');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('soldout').addClass('available');
                                        }
                                    }
                                });
                            } else {
                                selectOption.each((idx, elt) => {
                                    var $option = $(elt),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option3List.find((variant) => {
                                        return variant.option1 == this.decodeOption(optionValue)
                                    });
    
                                   if(optionSoldout == undefined){
                                      $option.attr('disabled', true);
                                      if (checkStickyVariant) {
                                          $(inputSticky[idx]).attr('disabled', true);
                                      }
                                  } else {
                                      $option.removeAttr('disabled');
                                      if (checkStickyVariant) {
                                          $(inputSticky[idx]).removeAttr('disabled');
                                      }
                                  }
                                });
                            }
                        }
    
                        if(selectedOption2){
                            var inputList = $(options[1]),
                                input = inputList.find('.product-form__radio');
    
                            if(type == 'set-rectangle'){
                                input.each((idx, elt) => {
                                    var $input = $(elt),
                                        $label = $input.next(),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option3List.find((variant) => {
                                        return variant.option2 == this.decodeOption(optionValue)
                                    });
    
                                    if(optionSoldout == undefined){
                                        $label.removeClass('available').addClass('soldout');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('available').addClass('soldout');
                                        }
                                    } else {
                                        $label.removeClass('soldout').addClass('available');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).next().removeClass('soldout').addClass('available');
                                        }
                                    }
                                });
                            } else {
                                selectOption.each((idx, elt) => {
                                    var $option = $(elt),
                                        optionValue = $(elt).val();
    
                                    var optionSoldout = option3List.find((variant) => {
                                        return variant.option2 == this.decodeOption(optionValue)
                                    });
    
                                     if(optionSoldout == undefined){
                                        $option.attr('disabled', true);
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).attr('disabled', true);
                                        }
                                    } else {
                                        $option.removeAttr('disabled');
                                        if (checkStickyVariant) {
                                            $(inputSticky[idx]).removeAttr('disabled');
                                        }
                                    }
                                });
                            }
                        }
                        
                        break;
                }
            }); 
        }

        renderOptions(options)
        renderOptions(optionsMobile)

        if(this.item.find('[data-sku]').length > 0 && this.currentVariant){
            this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku);
        }

        var inventory = this.currentVariant?.inventory_management;

        if(inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inventoryQuantity = parseInt(inven_num);
              
                 this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);

                if(this.item.find('[data-inventory]').length > 0){
                    if(inventoryQuantity > 0){
                        this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
                    } else {
                        this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
                    }
                }

                if(this.item.find('.productView-hotStock').length > 0){
                    var hotStock = this.item.find('.productView-hotStock'),
                        maxStock = hotStock.data('hot-stock');

                    if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
                        var textStock = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
                        hotStock.text(textStock).show();
                    } else {
                        hotStock.hide();
                    }
                }
            }
        }
    }

    updateAttribute(disable = true){
        var oDom = $('[data-sticky-add-to-cart]')
        if (this.currentVariant && this.currentVariant.compare_at_price) {
            var isFlash = oDom.find('.sticky-actions').attr('data-flash') == 'true';
            var isFlashNew = oDom.find('.sticky-actions').attr('data-flash-new') == 'true';
            if (this.currentVariant.compare_at_price == this.currentVariant.price) {
                oDom.find('[name="properties[_is_final_sale]"]').remove();
            } else {
                if (!oDom.find('[name="properties[_is_final_sale]"]').length && !oDom.find('[name="properties[_is_final_sale_bgf]"]').length) {
                    oDom.find('.productView-quantity').before('<input type="hidden" name="properties[_is_final_sale]" value="yes">')
                }
            }
        }
        // const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        const stickyButton = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelectorAll('[name="add"]');
        var isSelectSize = $(this.item).find('.product-form__input:not(.product-form__swatch) input:checked');

        var quantityInput = $('[data-sticky-add-to-cart] .quantity__input'),
            notifyMe = this.item.find('.productView-notifyMe'),
            stickyPrice = $('[data-sticky-add-to-cart] .sticky-price .money');
        
        var maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

        if (stickyPrice.length === 0) {
           stickyPrice = $('[data-sticky-add-to-cart] .sticky-price .money-subtotal')
        }
        // $('variant-radios').closest('.productView-details').find('.subscription-bis-trigger').hide();
        if (!isSelectSize.length) return;
        if (disable) {
            var text = window.variantStrings.soldOut;

            this.item.removeClass('isChecked');
            quantityInput.attr('data-price', this.currentVariant?.price);
            quantityInput.attr('disabled', true);
            // addButton.setAttribute('disabled', true);
            // addButton.textContent = text;
            // $('variant-radios').closest('.productView-details').find('.subscription-bis-trigger').css('display', 'block');
            stickyButton.forEach(el => {
                el.setAttribute('disabled', true);
                el.textContent = text;
            })

            if(notifyMe.length > 0){
                notifyMe.find('input[name="halo-notify-product-variant"]').val(this.currentVariant.title);
                notifyMe.find('.notifyMe-text').empty();
                notifyMe.slideDown('slow');
            }
        } else{
            
            var text,
                subTotal = 0,
                price = this.currentVariant?.price;

            if(window.subtotal.show) {
                let qty = quantityInput.val();
              
                subTotal = qty * price;
                subTotal = Shopify.formatMoney(subTotal, window.money_format);
                if (window.currencyFormatted) subTotal = $(subTotal).text();
               
                if (window.subtotal.style == '1') {
                    const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                    pdView_subTotal.textContent = subTotal;
                    // console.log(maxValue);
                    if (this.currentVariant && this.currentVariant.available && maxValue <= 0) {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }
                }
                else if (window.subtotal.style == '2') {
                    text = window.subtotal.text.replace('[value]', subTotal);
                }
            } else {
                subTotal = Shopify.formatMoney(price, window.money_format);
                if (window.currencyFormatted) subTotal = $(subTotal).text();
                if (this.currentVariant && this.currentVariant.available && maxValue <= 0) {
                    text = window.variantStrings.preOrder;
                } else {
                    text = window.variantStrings.addToCart;
                }
            }

            this.item.addClass('isChecked');
            quantityInput.attr('data-price', this.currentVariant?.price);
            quantityInput.attr('disabled', false);
            // addButton.removeAttribute('disabled');
            // addButton.textContent = text;
            stickyButton.forEach(el => {
                el.removeAttribute('disabled');
                el.textContent = text;
            })

            if (subTotal != 0 && stickyPrice.length) {
                stickyPrice.text(subTotal);
            }

            if(notifyMe.length > 0){
                notifyMe.slideUp('slow');
            }
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-sticky-selects', VariantStickyAddToCart);

class VariantStickyRadios extends VariantStickyAddToCart {
    constructor() {
        super();        
    }

    connectedCallback() {
        this.updateMediaTimeout = undefined
    }

    onVariantChange(event) {
        this.updateOptions();   
        this.updateMasterId();
        this.updatePickupAvailability();
        if ($(event.target).parents('.product-form__input').hasClass('error')) {
            $(event.target).parents('.product-form__input').removeClass('error');
        }
        if (!this.currentVariant) {
            this.updateVariants(this.getVariantData());
            var value = $(event.target).val(); 
            $(event.target).parents('.product-form__swatch').find('[data-header-option]').text(value);
            $('variant-radios').find('.product-form__input.product-form__swatch input[value="'+ value +'"]').click();
            this.updateAttribute(true);
        } else {
            this.updateMedia(10);
            if (!$('.combined-size:not(.active)').length) {
                // this.updateURL();
            }
            this.updateVariantInput();
            this.updateSelectVariant();
            this.renderProductAjaxInfo();
            this.renderProductInfo();
            this.updateAttribute(!this.currentVariant.available);
        }
    } 
    updateVariants(variants){
        const options = Array.from(this.querySelectorAll('.product-form__input'));

        let selectedOption1;
        let selectedOption2;
        let selectedOption3;

        if (variants) {
            if (options[0] && Array.from(options[0].querySelectorAll('input')).find((radio) => radio.checked)) {
                selectedOption1 = Array.from(options[0].querySelectorAll('input')).find((radio) => radio.checked).value;
                options[0].querySelector('[data-header-option]').textContent = selectedOption1;
            }

            if (options[1]) {
                var sizeChecked = Array.from(options[1].querySelectorAll('input')).find((radio) => radio.checked);
                $(sizeChecked).length && (selectedOption2 = $(sizeChecked).val());
                try {
                    var specialSizes = $(options[1]).closest('.productView-options').attr('data-special-sizes');
                    if (specialSizes) {
                        var S = this
                        var sizes = JSON.parse(specialSizes);
                        var sku =  $('variant-sticky-radios .product-form__swatch').find('input:checked') ?  $('variant-sticky-radios .product-form__swatch').find('input:checked').attr('data-sku') : $('[data-sku] .productView-info-value').html();
                        if (sku.indexOf(sizes.handle) > -1 || sizes.handle == 'goelia-gift-box') {

                            var hideSizesMap = {}; // 用对象存储需要隐藏的尺寸，减少 indexOf 查找次数
                            var matchedSpu = false; // 是否找到匹配的 spu

                            sizes.productUnits.forEach(function(dc) {
                                if (sku.indexOf(dc.spu) > -1) {
                                    matchedSpu = true;
                                    dc.sizes.forEach(function(size) {
                                        hideSizesMap[size] = true; // 直接用对象存储，判断更快
                                    });
                                }
                            });

                            // 遍历 radio 选项，一次性完成 `hidden` 处理 & 选择新尺寸
                            var newSelectedSize = null;

                            $(options[1]).find('.product-form__radio').each(function () {
                                var value = $(this).val();
                                var $label = $(this).next();

                                if (hideSizesMap[value]) {
                                    $label.addClass('hidden'); // 需要隐藏
                                } else {
                                    $label.removeClass('hidden'); // 需要显示

                                    // 选择第一个可用尺寸
                                    if (!newSelectedSize && $label.hasClass('available')) {
                                        newSelectedSize = value;
                                    }
                                }
                            });

                            var variantList = variants.filter(acc => acc.option1 == selectedOption1 && acc.option2 == newSelectedSize);
                            if (variantList.length && !variantList[0].available) {
                                var variantListNew = variants.filter(acc => acc.option1 == selectedOption1 && acc.available);
                                if (variantListNew.length) {
                                    newSelectedSize = variantListNew[0].option2;
                                }
                            }

                            if (!variantList.length) {
                                var variantListNew2 = variants.filter(acc => acc.option1 == selectedOption1 && acc.available);
                                variantListNew2.length && (newSelectedSize = variantListNew2[0].option2);
                            }

                            // 如果当前选中的尺寸被隐藏，就自动选择新尺寸
                            if (S.currentVariant && matchedSpu && hideSizesMap[S.currentVariant.option2] && newSelectedSize) {
                                $(options[1]).find('.product-form__radio[value="' + newSelectedSize + '"]').click();
                                selectedOption2 = newSelectedSize;
                            }
                        }
                    }
                } catch (err) {}
                options[1].querySelector('[data-header-option]').textContent = selectedOption2;
            }

            if (options[2] && Array.from(options[2].querySelectorAll('input')).find((radio) => radio.checked)) {
                selectedOption3 = Array.from(options[2].querySelectorAll('input')).find((radio) => radio.checked).value;
                options[2].querySelector('[data-header-option]').textContent = selectedOption3;
            }

            var checkVariant = () => {
                var optionsSize = parseInt(options.length);

                if(optionsSize > 1){
                    var variantList = variants.filter((variant) => {
                        switch (optionsSize) {
                            case 2: return variant.option2 === selectedOption2;
                            case 3: return variant.option3 === selectedOption3;
                        }
                    });
                    if (!variantList.length) {
                        variantList = variants[0];
                    }

                    var isSelectSize = $(this.item).find('.product-form__input:not(.product-form__swatch) input:checked');

                    isSelectSize.length && input1List.forEach((input) => {
                        var label = input.nextSibling;
                        var optionSoldout = Array.from(variantList).find((variant) => {
                            return variant.option1 == input.value && variant.available;
                        });

                        var optionUnavailable = Array.from(variantList).find((variant) => {
                            return variant.option1 == input.value;
                        });

                        if(optionSoldout == undefined){
                            if (optionUnavailable == undefined) {
                                label.classList.remove('available');
                                label.classList.remove('soldout');
                                label.classList.add('unavailable');
                            } else {
                                label.classList.remove('available');
                                label.classList.remove('unavailable');
                                label.classList.add('soldout');
                            }
                        } else {
                            label.classList.remove('soldout');
                            label.classList.remove('unavailable');
                            label.classList.add('available');
                        }
                    });
                }
            };

            var updateVariant = (optionSoldout, optionUnavailable, element, optionIndex) => {
                var label = element.nextSibling;

                if(optionSoldout == undefined){
                    if (optionUnavailable == undefined) {
                        label.classList.remove('available');
                        label.classList.remove('soldout');
                        label.classList.add('unavailable');
                    } else {
                        label.classList.remove('available');
                        label.classList.remove('unavailable');
                        label.classList.add('soldout');
                    }
                } else {
                    label.classList.remove('soldout');
                    label.classList.remove('unavailable');
                    label.classList.add('available');
                }
            };

            var renderVariant = (optionIndex, fieldset) => {
                const inputList = fieldset.querySelectorAll('.product-form__radio');

                inputList.forEach((input) => {
                    const inputVal = input.value;

                    const optionSoldout = variants.find((variant) => {
                        switch (optionIndex) {
                            case 0: return variant.option1 == inputVal && variant.available;
                            case 1: return variant.option1 == selectedOption1 && variant.option2 == inputVal && variant.available;
                            case 2: return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == inputVal && variant.available;
                        }
                    });

                    const optionUnavailable = variants.find((variant) => {
                        switch (optionIndex) {
                            case 0: return variant.option1 == inputVal;
                            case 1: return variant.option1 == selectedOption1 && variant.option2 == inputVal;
                            case 2: return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == inputVal;
                        }
                    });

                    updateVariant(optionSoldout, optionUnavailable, input, optionIndex);
                });
            };
            

            options.forEach((fieldset) => {
                const optionIndex = parseInt(fieldset.getAttribute('data-option-index'));

                renderVariant(optionIndex, fieldset);
                checkVariant();
            });
        }
    }  

    updateOptions() {   
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        });
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
  
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }

    updateSelectVariant() {
        const selectElement = this.closest('.productView-stickyCart').querySelector('select');
        if (this.currentVariant) {
            selectElement.value = this.currentVariant.id
        }
    }

    updateMasterId() {
        this.decodeOptions()
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;

        const itemImage = this.item.find('.sticky-image');
        const image = this.currentVariant?.featured_image;
        if (!itemImage) return;

        itemImage.find('img').attr({
            'src': image.src,
            'srcset': image.src,
            'alt': image.alt
        });

        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;
        
        clearTimeout(this.updateMediaTimeout);
        this.updateMediaTimeout = setTimeout(() => {
            $(newMedia).trigger('click');
        }, time);
    }

    openStickyModal() {
        document.body.classList.add('show-mobile-options');
    }

    closeStickyModal() {
        document.body.classList.remove('show-mobile-options');
    }
}

customElements.define('variant-sticky-radios', VariantStickyRadios);

function parseDoubleQuote(option, isDecoding = true) {
    if (!option) return option;
    
    if (isDecoding) {
      return option.replace('"', 'spc_dbl_qte')
    } else {
      return option.replace('spc_dbl_qte', '"')
    }
}